import { RepresentationData } from '@ardoq/data-model';
import { ComponentRepresentation } from '@ardoq/basic-components';
import React from 'react';
import styled from 'styled-components';
import { ICON_MARGIN, ICON_WIDTH } from '../consts';

const LabelIconContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${ICON_MARGIN}px;
  margin-right: ${ICON_MARGIN}px;
  width: ${ICON_WIDTH}px;
  height: ${ICON_WIDTH}px;
  font-size: 18px;
`;

type ComponentIconContainerArgs = {
  color?: string;
  componentRepresentationData: RepresentationData;
  itemClass: string;
};

export const ComponentIcon = ({
  color,
  itemClass,
  componentRepresentationData,
}: ComponentIconContainerArgs) => (
  <LabelIconContainer
    className={itemClass}
    style={color ? { color } : undefined}
    aria-label={`Component icon color: ${color}`}
  >
    <ComponentRepresentation {...componentRepresentationData} />
  </LabelIconContainer>
);
